/**
 * Simply remove the no-js classname from the document body
 */
export const stickyBanner = () => {
	const scrollBox = document.querySelector('.scroll-box');
	const outerContainer = document.querySelector('.scroll-block-outer');
	if (scrollBox) {
		function checkOffset() {
			function getRectTop(el) {
				const rect = el.getBoundingClientRect();
				return rect.top;
			}

			if (
				getRectTop(scrollBox) +
					document.body.scrollTop +
					scrollBox.offsetHeight >=
				getRectTop(outerContainer) + document.body.scrollTop - 10
			)
				scrollBox.style.position = 'relative';
			if (
				document.body.scrollTop + window.innerHeight <
				getRectTop(outerContainer) + document.body.scrollTop
			)
				scrollBox.style.position = 'fixed'; // restore when you scroll up
		}

		document.addEventListener('scroll', function () {
			checkOffset();
		});
	}
};
